// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-flipclock {
  position: relative;
  z-index: 1;
  width: 100%;
  padding-bottom: 1em;
  margin-top: -10px;
  font-size: 300%;
  font-weight: bold;
  font-feature-settings: "tnum";
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  line-height: 1.4;
  user-select: none;
  cursor: default;
}
.srprs-flipclock * {
  box-sizing: inherit;
}
.srprs-flipclock [data-view] {
  max-width: 100%;
}
.srprs-flipclock span[data-view] {
  display: inline-block;
}
.srprs-flipclock [data-layout~=pad] {
  margin: -0.25em;
}
.srprs-flipclock [data-layout~=pad] > * {
  margin: 0.25em;
}
.srprs-flipclock [data-layout~=horizontal] {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=baseline] {
  align-items: baseline;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=center] {
  justify-content: center;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=right] {
  justify-content: flex-end;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=left] {
  justify-content: flex-start;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=stretch], .srprs-flipclock [data-layout~=horizontal][data-layout~=fill] {
  align-content: stretch;
  flex-wrap: nowrap;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=stretch] > *, .srprs-flipclock [data-layout~=horizontal][data-layout~=fill] > * {
  flex: 1 0 0;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=stretch] > *, .srprs-flipclock [data-layout~=horizontal][data-layout~=fill] > * {
  width: 100%;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=multi-line] {
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.srprs-flipclock [data-layout~=horizontal][data-layout~=fit] {
  display: inline-flex;
  flex-wrap: nowrap;
  align-content: center;
  white-space: nowrap;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.srprs-flipclock [data-layout~=vertical] {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=top] {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=bottom] {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  min-height: 100%;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=middle] {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  min-height: 100%;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=left] {
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=right] {
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=center] {
  text-align: center;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=stretch], .srprs-flipclock [data-layout~=vertical][data-layout~=fill] {
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 100%;
}
.srprs-flipclock [data-layout~=vertical][data-layout~=stretch] > *, .srprs-flipclock [data-layout~=vertical][data-layout~=fill] > * {
  -webkit-box-flex: 1;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
}
.srprs-flipclock [data-layout~=vertical] > * + * {
  margin-top: 0.5em;
}
.srprs-flipclock [data-layout~=overlay] {
  position: relative;
}
.srprs-flipclock [data-layout~=overlay] > * {
  margin: 0;
}
.srprs-flipclock [data-layout~=overlay][data-layout~=center] {
  text-align: center;
}
.srprs-flipclock [data-layout~=overlay][data-layout~=left] {
  text-align: left;
}
.srprs-flipclock [data-layout~=overlay][data-layout~=right] {
  text-align: right;
}
.srprs-flipclock [data-layout~=overlay] > [data-overlay=stretch],
.srprs-flipclock [data-layout~=overlay] > [data-overlay=fill] {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.srprs-flipclock [data-layout~=overlay] > [data-overlay=center] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.tick-flip {
  position: relative;
  text-align: center;
}
.tick-flip * {
  border-radius: 0;
  white-space: pre;
  letter-spacing: inherit;
  text-indent: inherit;
}

.tick-flip-front {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.tick-flip-back {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.tick-flip-spacer {
  display: block;
  visibility: hidden;
}

.tick-flip-shadow {
  position: absolute;
  left: 1px;
  right: 1px;
  top: 1px;
  bottom: 1px;
  color: transparent !important;
  background: transparent !important;
}

.tick-flip-shadow-top {
  bottom: calc(50% - 1px);
}

.tick-flip-shadow-bottom {
  top: calc(50% + 1px);
}

.tick-flip-card-shadow {
  position: absolute;
  left: 0.15em;
  right: 0.15em;
  bottom: 0.125em;
  height: 0.5em;
  background-color: transparent;
  border-radius: 0;
  opacity: 0;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  box-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.5), 0 0.125em 0.5em rgba(0, 0, 0, 0.75);
  z-index: 0;
}

/**
 * Card
 */
.tick-flip-card {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-perspective: 4em;
  perspective: 4em;
}

.tick-flip-panel-front,
.tick-flip-panel-back {
  position: absolute;
  left: 0;
  width: 100%;
  height: 51%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.tick-flip-panel-front-text,
.tick-flip-panel-back-text {
  position: absolute;
  left: -1px;
  top: 0;
  right: -1px;
  height: 100%;
  overflow: hidden;
}

.tick-flip-panel-text-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
}

.tick-flip-panel-back-text .tick-flip-panel-text-wrapper {
  height: 200%;
  top: -100%;
}

.tick-flip-panel-front {
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  top: 0;
  z-index: 2;
  box-shadow: inset 0 1px rgba(255, 255, 255, 0.05);
}

.tick-flip-panel-back {
  -webkit-transform-origin: center top;
  transform-origin: center top;
  top: 50%;
  z-index: 1;
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);
}
.tick-flip-panel-back:after {
  z-index: 1;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  background-color: #222;
}

.tick-flip-panel-back-shadow {
  z-index: 2;
}

.tick-flip-panel-back-highlight {
  z-index: 3;
}

.tick-flip-panel-back-shadow,
.tick-flip-panel-back-highlight {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.tick-flip-panel-front-shadow,
.tick-flip-panel-back-shadow,
.tick-flip-panel-back-highlight {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
}

.tick-flip-panel-front-shadow {
  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3));
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3));
}

.tick-flip-panel-back-shadow {
  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5));
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5));
}

.tick-flip-panel-back-highlight {
  background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.3));
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.3));
}

.tick [data-style*="shadow:inner"] {
  box-shadow: none;
}
.tick [data-style*="shadow:inner"] .tick-flip-card-shadow {
  box-shadow: none;
}
.tick [data-style*="shadow:none"] .tick-flip-panel-front,
.tick [data-style*="shadow:none"] .tick-flip-panel-back,
.tick [data-style*="shadow:none"] .tick-flip-shadow,
.tick [data-style*="shadow:none"] .tick-flip-card-shadow {
  box-shadow: none;
}
.tick [data-style*="shadow:none"] .tick-flip-back::after,
.tick [data-style*="shadow:none"] .tick-flip-panel-front-shadow,
.tick [data-style*="shadow:none"] .tick-flip-panel-back-shadow,
.tick [data-style*="shadow:none"] .tick-flip-panel-back-text::after {
  background-image: none;
}
.tick [data-style*="rounded:none"] {
  border-radius: 0;
}
.tick [data-style*="rounded:panels"] .tick-flip-shadow-bottom,
.tick [data-style*="rounded:panels"] .tick-flip-front {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.tick [data-style*="rounded:panels"] .tick-flip-shadow-top,
.tick [data-style*="rounded:panels"] .tick-flip-panel-back::after,
.tick [data-style*="rounded:panels"] .tick-flip-back {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.tick-flip {
  margin-left: 0.0625em;
  margin-right: 0.0625em;
  min-width: 1.125em;
  min-height: 1.125em;
  border-radius: 0.125em;
  letter-spacing: 0.25em;
  text-indent: 0.25em;
}

.tick-flip-panel {
  color: #222;
  background-color: #fff;
}

.tick-group {
  position: relative;
  margin-right: 0.35em;
}
.tick-group .tick-label {
  position: absolute;
  bottom: -1.75em;
  left: 0.0625em;
  text-transform: uppercase;
  font-size: 0.4em;
  font-weight: 800;
}
.tick-group:last-child {
  margin-right: 0;
}

@media screen and (min-width: 768px) {
  .srprs-flipclock {
    margin-top: 40px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-flipclock {
    max-width: 750px;
  }
  .srprs-flipclock .tick-label {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Flipclock/Flipclock.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEE,mBAAA;EAGA,iBAAA;EAGA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,2IAAA;EAEF,gBAAA;EACA,iBAAA;EACA,eAAA;AAiMF;AAhME;EACE,mBAAA;AAkMJ;AAhME;EACE,eAAA;AAkMJ;AAhME;EACE,qBAAA;AAkMJ;AAhME;EACE,eAAA;AAkMJ;AAjMI;EACE,cAAA;AAmMN;AAhME;EACE,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;AAkMJ;AAjMI;EACE,qBAAA;AAmMN;AAjMI;EACE,uBAAA;AAmMN;AAjMI;EACE,yBAAA;AAmMN;AAjMI;EACE,2BAAA;AAmMN;AAjMI;EAEE,sBAAA;EACA,iBAAA;AAkMN;AAhMI;EAEE,WAAA;AAiMN;AA/LI;EAEE,WAAA;AAgMN;AA9LI;EACE,uBAAA;EACA,mBAAA;EACA,eAAA;AAgMN;AA9LI;EACE,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oBAAA;EACA,2BAAA;AAgMN;AA7LE;EACE,aAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;AA+LJ;AA9LI;EACE,uBAAA;EACA,mCAAA;EACA,oBAAA;EACA,2BAAA;AAgMN;AA9LI;EACE,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAgMN;AA9LI;EACE,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;AAgMN;AA9LI;EACE,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;AAgMN;AA9LI;EACE,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;AAgMN;AA9LI;EACE,kBAAA;AAgMN;AA9LI;EAEE,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AA+LN;AA7LI;EAEE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AA8LN;AA5LI;EACE,iBAAA;AA8LN;AA3LE;EACE,kBAAA;AA6LJ;AA5LI;EACE,SAAA;AA8LN;AA5LI;EACE,kBAAA;AA8LN;AA5LI;EACE,gBAAA;AA8LN;AA5LI;EACE,iBAAA;AA8LN;AA3LM;;EAEE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AA6LR;AA3LM;EACE,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AA6LR;;AAvLA;EACE,kBAAA;EACA,kBAAA;AA0LF;AAzLE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AA2LJ;;AAvLA;EACE,4BAAA;EACA,6BAAA;AA0LF;;AAvLA;EACE,yBAAA;EACA,0BAAA;AA0LF;;AAvLA;EACE,cAAA;EACA,kBAAA;AA0LF;;AAvLA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;EACA,kCAAA;AA0LF;;AAvLA;EACE,uBAAA;AA0LF;;AAvLA;EACE,oBAAA;AA0LF;;AAvLA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,gCAAA;EACA,wBAAA;EACA,oFAAA;EAEA,UAAA;AAyLF;;AAtLA;;EAAA;AAIA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;AAwLF;;AArLA;;EAEE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,2BAAA;EACA,oCAAA;EACA,4BAAA;AAwLF;;AArLA;;EAEE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAwLF;;AArLA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AAwLF;;AArLA;EACE,YAAA;EACA,UAAA;AAwLF;;AArLA;EACE,uCAAA;EACA,+BAAA;EACA,MAAA;EACA,UAAA;EACA,iDAAA;AAwLF;;AArLA;EACE,oCAAA;EACA,4BAAA;EACA,QAAA;EACA,UAAA;EACA,2CAAA;AAwLF;AAvLE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EAEE,sBAAA;AAwLN;;AAlLA;EACE,UAAA;AAqLF;;AAlLA;EACE,UAAA;AAqLF;;AAlLA;;EAEE,4BAAA;EACA,6BAAA;AAqLF;;AAlLA;;;EAGE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAqLF;;AAlLA;EACE,yFAAA;EAKA,iFAAA;AAiLF;;AA1KA;EACE,sFAAA;EAKA,oFAAA;AAyKF;;AAlKA;EACE,mGAAA;EAKA,iGAAA;AAiKF;;AAzJE;EACE,gBAAA;AA4JJ;AA3JI;EACE,gBAAA;AA6JN;AAzJI;;;;EAIE,gBAAA;AA2JN;AAzJI;;;;EAIE,sBAAA;AA2JN;AAxJE;EACE,gBAAA;AA0JJ;AAvJI;;EAEE,kCAAA;EACA,mCAAA;AAyJN;AAvJI;;;EAGE,+BAAA;EACA,gCAAA;AAyJN;;AApJA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AAuJF;;AApJA;EACE,WAAA;EACA,sBAAA;AAuJF;;AAhJA;EACE,kBAAA;EAEE,oBAAA;AAkJJ;AAhJE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EAEE,yBAAA;EAGA,gBAAA;EACA,gBAAA;AA+IN;AApDE;EAEI,eAAA;AAqDN;;ACxmBI;EDyjBF;IAEI,gBAAA;EAkDJ;AACF;AC9mBI;EDikBF;IACE,gBAAA;EAgDF;EA/CE;IAEI,eAAA;EAgDN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-flipclock {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  padding: {\n    bottom: 1em;\n  }\n  margin: {\n    top: -10px;\n  }\n  font: {\n    size: 300%;\n    weight: bold;\n    feature-settings: 'tnum';\n    family: font(heading);\n  }\n  line-height: 1.4;\n  user-select: none;\n  cursor: default;\n  * {\n    box-sizing: inherit;\n  }\n  [data-view] {\n    max-width: 100%;\n  }\n  span[data-view] {\n    display: inline-block;\n  }\n  [data-layout~='pad'] {\n    margin: -0.25em;\n    > * {\n      margin: 0.25em;\n    }\n  }\n  [data-layout~='horizontal'] {\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    &[data-layout~='baseline'] {\n      align-items: baseline;\n    }\n    &[data-layout~='center'] {\n      justify-content: center;\n    }\n    &[data-layout~='right'] {\n      justify-content: flex-end;\n    }\n    &[data-layout~='left'] {\n      justify-content: flex-start;\n    }\n    &[data-layout~='stretch'],\n    &[data-layout~='fill'] {\n      align-content: stretch;\n      flex-wrap: nowrap;\n    }\n    &[data-layout~='stretch'] > *,\n    &[data-layout~='fill'] > * {\n      flex: 1 0 0;\n    }\n    &[data-layout~='stretch'] > *,\n    &[data-layout~='fill'] > * {\n      width: 100%;\n    }\n    &[data-layout~='multi-line'] {\n      -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n    }\n    &[data-layout~='fit'] {\n      display: inline-flex;\n      flex-wrap: nowrap;\n      align-content: center;\n      white-space: nowrap;\n      -webkit-box-pack: start;\n      -webkit-justify-content: flex-start;\n      -ms-flex-pack: start;\n      justify-content: flex-start;\n    }\n  }\n  [data-layout~='vertical'] {\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    &[data-layout~='top'] {\n      -webkit-box-pack: start;\n      -webkit-justify-content: flex-start;\n      -ms-flex-pack: start;\n      justify-content: flex-start;\n    }\n    &[data-layout~='bottom'] {\n      -webkit-box-pack: end;\n      -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n      justify-content: flex-end;\n      min-height: 100%;\n    }\n    &[data-layout~='middle'] {\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n      -ms-flex-pack: center;\n      justify-content: center;\n      min-height: 100%;\n    }\n    &[data-layout~='left'] {\n      -webkit-box-align: start;\n      -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n      align-items: flex-start;\n    }\n    &[data-layout~='right'] {\n      -webkit-box-align: end;\n      -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n      align-items: flex-end;\n    }\n    &[data-layout~='center'] {\n      text-align: center;\n    }\n    &[data-layout~='stretch'],\n    &[data-layout~='fill'] {\n      -webkit-box-align: stretch;\n      -webkit-align-items: stretch;\n      -ms-flex-align: stretch;\n      align-items: stretch;\n      min-height: 100%;\n    }\n    &[data-layout~='stretch'] > *,\n    &[data-layout~='fill'] > * {\n      -webkit-box-flex: 1;\n      -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n      flex: 1 0 0;\n    }\n    > * + * {\n      margin-top: 0.5em;\n    }\n  }\n  [data-layout~='overlay'] {\n    position: relative;\n    > * {\n      margin: 0;\n    }\n    &[data-layout~='center'] {\n      text-align: center;\n    }\n    &[data-layout~='left'] {\n      text-align: left;\n    }\n    &[data-layout~='right'] {\n      text-align: right;\n    }\n    > {\n      [data-overlay='stretch'],\n      [data-overlay='fill'] {\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n      }\n      [data-overlay='center'] {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n      }\n    }\n  }\n}\n\n.tick-flip {\n  position: relative;\n  text-align: center;\n  * {\n    border-radius: 0;\n    white-space: pre;\n    letter-spacing: inherit;\n    text-indent: inherit;\n  }\n}\n\n.tick-flip-front {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.tick-flip-back {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.tick-flip-spacer {\n  display: block;\n  visibility: hidden;\n}\n\n.tick-flip-shadow {\n  position: absolute;\n  left: 1px;\n  right: 1px;\n  top: 1px;\n  bottom: 1px;\n  color: transparent !important;\n  background: transparent !important;\n}\n\n.tick-flip-shadow-top {\n  bottom: calc(50% - 1px);\n}\n\n.tick-flip-shadow-bottom {\n  top: calc(50% + 1px);\n}\n\n.tick-flip-card-shadow {\n  position: absolute;\n  left: 0.15em;\n  right: 0.15em;\n  bottom: 0.125em;\n  height: 0.5em;\n  background-color: transparent;\n  border-radius: 0;\n  opacity: 0;\n  -webkit-transform-origin: 0 100%;\n  transform-origin: 0 100%;\n  box-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.5),\n    0 0.125em 0.5em rgba(0, 0, 0, 0.75);\n  z-index: 0;\n}\n\n/**\n * Card\n */\n\n.tick-flip-card {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-perspective: 4em;\n  perspective: 4em;\n}\n\n.tick-flip-panel-front,\n.tick-flip-panel-back {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 51%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n\n.tick-flip-panel-front-text,\n.tick-flip-panel-back-text {\n  position: absolute;\n  left: -1px;\n  top: 0;\n  right: -1px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.tick-flip-panel-text-wrapper {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n\n.tick-flip-panel-back-text .tick-flip-panel-text-wrapper {\n  height: 200%;\n  top: -100%;\n}\n\n.tick-flip-panel-front {\n  -webkit-transform-origin: center bottom;\n  transform-origin: center bottom;\n  top: 0;\n  z-index: 2;\n  box-shadow: inset 0 1px rgba(255, 255, 255, 0.05);\n}\n\n.tick-flip-panel-back {\n  -webkit-transform-origin: center top;\n  transform-origin: center top;\n  top: 50%;\n  z-index: 1;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);\n  &:after {\n    z-index: 1;\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 1px;\n    background: {\n      color: color(black);\n    }\n    //background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 1px, rgba(0, 0, 0, 0.15) 1px, transparent 30%);\n  }\n}\n\n.tick-flip-panel-back-shadow {\n  z-index: 2;\n}\n\n.tick-flip-panel-back-highlight {\n  z-index: 3;\n}\n\n.tick-flip-panel-back-shadow,\n.tick-flip-panel-back-highlight {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.tick-flip-panel-front-shadow,\n.tick-flip-panel-back-shadow,\n.tick-flip-panel-back-highlight {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n}\n\n.tick-flip-panel-front-shadow {\n  background-image: -webkit-linear-gradient(\n    bottom,\n    rgba(0, 0, 0, 0.8),\n    rgba(0, 0, 0, 0.3)\n  );\n  background-image: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.8),\n    rgba(0, 0, 0, 0.3)\n  );\n}\n\n.tick-flip-panel-back-shadow {\n  background-image: -webkit-linear-gradient(\n    top,\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.5)\n  );\n  background-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.5)\n  );\n}\n\n.tick-flip-panel-back-highlight {\n  background-image: -webkit-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.15),\n    rgba(255, 255, 255, 0.3)\n  );\n  background-image: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0.15),\n    rgba(255, 255, 255, 0.3)\n  );\n}\n\n.tick {\n  [data-style*='shadow:inner'] {\n    box-shadow: none;\n    .tick-flip-card-shadow {\n      box-shadow: none;\n    }\n  }\n  [data-style*='shadow:none'] {\n    .tick-flip-panel-front,\n    .tick-flip-panel-back,\n    .tick-flip-shadow,\n    .tick-flip-card-shadow {\n      box-shadow: none;\n    }\n    .tick-flip-back::after,\n    .tick-flip-panel-front-shadow,\n    .tick-flip-panel-back-shadow,\n    .tick-flip-panel-back-text::after {\n      background-image: none;\n    }\n  }\n  [data-style*='rounded:none'] {\n    border-radius: 0;\n  }\n  [data-style*='rounded:panels'] {\n    .tick-flip-shadow-bottom,\n    .tick-flip-front {\n      border-bottom-left-radius: inherit;\n      border-bottom-right-radius: inherit;\n    }\n    .tick-flip-shadow-top,\n    .tick-flip-panel-back::after,\n    .tick-flip-back {\n      border-top-left-radius: inherit;\n      border-top-right-radius: inherit;\n    }\n  }\n}\n\n.tick-flip {\n  margin-left: 0.0625em;\n  margin-right: 0.0625em;\n  min-width: 1.125em;\n  min-height: 1.125em;\n  border-radius: 0.125em;\n  letter-spacing: 0.25em;\n  text-indent: 0.25em;\n}\n\n.tick-flip-panel {\n  color: color(black);\n  background-color: color(white);\n}\n\n.tick-flip-shadow {\n  //box-shadow: 0 0.125em 0.3125em rgba(0, 0, 0, 0.25), 0 0.02125em 0.06125em rgba(0, 0, 0, 0.25);\n}\n\n.tick-group {\n  position: relative;\n  margin: {\n    right: 0.35em;\n  }\n  .tick-label {\n    position: absolute;\n    bottom: -1.75em;\n    left: 0.0625em;\n    text: {\n      transform: uppercase;\n    }\n    font: {\n      size: 0.4em;\n      weight: 800;\n    }\n  }\n  //// translations: by default we use NL\n  //&:nth-child(1) {\n  //\t&:after {\n  //\t\tcontent: \"dagen\";\n  //\t}\n  //}\n  //&:nth-child(2) {\n  //\t&:after {\n  //\t\tcontent: \"uur\";\n  //\t}\n  //}\n  //&:nth-child(3) {\n  //\t&:after {\n  //\t\tcontent: \"min\";\n  //\t}\n  //}\n  //&:nth-child(4) {\n  //\t&:after {\n  //\t\tcontent: \"sec\";\n  //\t}\n  //}\n  //html[lang=\"en\"] & {\n  //\t&:nth-child(1) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"days\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(2) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"hours\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(3) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"min\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(4) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"sec\";\n  //\t\t}\n  //\t}\n  //}\n  //html[lang=\"de\"] & {\n  //\t&:nth-child(1) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"tagen\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(2) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"stunden\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(3) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"min\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(4) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"sek\";\n  //\t\t}\n  //\t}\n  //}\n  //html[lang=\"fr\"] & {\n  //\t&:nth-child(1) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"jours\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(2) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"heurs\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(3) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"min\";\n  //\t\t}\n  //\t}\n  //\t&:nth-child(4) {\n  //\t\t&:after {\n  //\t\t\tcontent: \"sec\";\n  //\t\t}\n  //\t}\n  //}\n\n  &:last-child {\n    margin: {\n      right: 0;\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-flipclock {\n    margin: {\n      top: 40px;\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-flipclock {\n    max-width: 750px;\n    .tick-label {\n      font: {\n        size: 22px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
